import { Component, OnInit, Input, ViewChild, OnDestroy } from "@angular/core";
import { RequisitionService } from "../../service/requisition/requisition.service";
import {
  Message,
  ConfirmationService,
  LazyLoadEvent,
  SelectItem,
  DataTable,
} from "primeng/primeng";
import { TranslateService } from "@ngx-translate/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { HasPermissionService } from "../../service/has-permission/has-permission.service";
import { CompanyService } from "../../service/company/company.service";
import { config } from "../../../../../environments/config";
import { Requisition } from "../../class/requisition";
import { RequisitionJustificationService } from "../../service/requisition-justification/requisition-justification.service";
import { RequisitionTaskService } from "../../service/requisition-task/requisition-task.service";
import { RequisitionTask } from "../../class/requisition-task";
import { formatDate } from "../../../../theme/functions/formatDate.function";
import { calendarES } from "../../../../theme/functions/calendarES";

@Component({
  selector: "app-requisitions",
  templateUrl: "./requisitions.component.html",
  styleUrls: ["./requisitions.component.scss"],
})
export class RequisitionsComponent implements OnInit, OnDestroy {
  @Input() customerGuide: number;
  @ViewChild("gb") searchFilter;
  @ViewChild("dt") dataTable: DataTable;

  public companyId: number;

  public promiseForm: Promise<any>;

  edit1: Requisition;
  public form: FormGroup;
  public form2: FormGroup;

  public msgs: Message[] = [];
  public requisitions: Requisition[];
  public selectRequisition: Requisition;
  public RequisitionID: Number = 0;
  public modNew = false;
  public modView = false;
  public openRequisition = false;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public filtersKanban: { key: string; value: string }[];
  public sort: string;
  public query: string;

  public form3: FormGroup;
  public requisitionRecruitments: SelectItem[];

  public profileSurveyLevelOptions: any[];
  public publishOfferOptions: any[];

  public statusOptions: SelectItem[];
  public typeOptions: SelectItem[];
  public exportOptions: SelectItem[];
  public ReportTypeExportOptions: SelectItem[];

  public selectedReportTypeExportOptions: { label: string; value: string };

  public params_id_customer_guide: number = 0;
  public params_id_company: number;
  public params_id_requisition: number;

  public employeePositionToLoadSelection: string;

  public filters: any[];

  public first = 0;

  public modExportDialog: boolean;

  public form4: FormGroup;
  public listRequisitionJustification: any[];
  public totalRecordsRequisitionJustification: number;
  public totalRecordsRequisitionTask: number;

  public displaySidebarJustification: boolean;
  public displaySidebarTask: boolean;

  public listAbierta: any;
  public listCerrada: any;

  public apiUrl = config.API_ROOT;

  public reloadInterval: any;
  public loading: boolean;

  public timeReload: number = 1200000;

  public showCreateTask: boolean;

  public es: any;

  public salaryMinOptions: any[] = [];
  public salaryMaxOptions: any[] = [];
  public salaryMin: number = 0;
  public salaryMax: number = 15;

  constructor(
    public requisitionService: RequisitionService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public activatedRoute: ActivatedRoute,
    public hasPermissionService: HasPermissionService,
    public router: Router,
    public companyService: CompanyService,
    public requisitionJustificationService: RequisitionJustificationService,
    public requisitionTaskService: RequisitionTaskService,
    public fb: FormBuilder
  ) {
    this.es = calendarES();

    this.showCreateTask = false;

    this.statusOptions = [
      { label: "Todas", value: "all" },
      { label: "Abierta", value: "Abierto" },
      { label: "En Proceso", value: "En Proceso" },
      { label: "Congelado", value: "Congelado" },
      { label: "Cancelada", value: "Cancelado" },
      { label: "Cerrada", value: "Cerrado" },
    ];

    let get_user_company = this.hasPermission("get user company");

    if (!get_user_company) {
      this.statusOptions.push({ label: "Retirada", value: "Retiro" });
      this.statusOptions.push({ label: "Backup", value: "Backup" });
    }

    this.typeOptions = [
      { label: "Todas", value: "all" },
      { label: "Proceso de Selección", value: "Proceso de Selección" },
      { label: "Enviado por el cliente", value: "Enviado por el cliente" },
      { label: "Reingreso", value: "Reingreso" },
    ];

    this.exportOptions = [
      { label: "Excel", value: "excel" },
      { label: "Pdf", value: "pdf" },
    ];

    this.ReportTypeExportOptions = [
      {
        label: "Reporte Requisición - General",
        value: "Reporte Requisición - General",
      },
      {
        label: "Reporte Requisición - Gerencia",
        value: "Reporte Requisición - Gerencia",
      },
      {
        label: "Reporte Requisición - Solicitados vs Enviados",
        value: "Reporte Requisición - Solicitados vs Enviados",
      },
      {
        label: "Reporte Requisición - Enviados vs Contratados",
        value: "Reporte Requisición - Enviados vs Contratados",
      },
      {
        label: "Reporte Requisición - Resumen Gestión",
        value: "Reporte Requisición - Resumen Gestión",
      },
      {
        label: "Reporte Requisición - Resumen Alentti",
        value: "Reporte Requisición - Alentti",
      },
      {
        label: "Reporte Requisición - Informe Contratación",
        value: "Reporte Requisición - Informe Contratación",
      },
      {
        label: "Reporte Requisición - Informe Psicólogos",
        value: "Reporte Requisición - Informe Psicólogos",
      },
    ];

    this.requisitionRecruitments = [
      { label: "Cualquiera", value: "" },
      { label: "Reclutamiento solicitado", value: "Reclutamiento solicitado" },
      {
        label: "Reclutamiento solicitado no asignado",
        value: "Reclutamiento solicitado no asignado",
      },
    ];

    this.profileSurveyLevelOptions = [
      { label: "Nivel perfil de cargo", value: "" },
      {
        id: 1,
        label: "Education not require",
        value: "Educación no requerida",
      },
      { id: 2, label: "Secondary", value: "Bachillerato" },
      { id: 3, label: "Technical - Technology", value: "Técnico - Tecnólogo" },
      { id: 4, label: "Professional", value: "Profesional" },
      { id: 5, label: "Postgraduate", value: "Posgrado" },
    ];

    this.publishOfferOptions = [
      { label: "¿Oferta publicada?", value: "" },
      { label: "Sí", value: true },
      { label: "No", value: false },
    ];

    for (let i = this.salaryMin; i <= this.salaryMax; i++)
      this.salaryMinOptions.push({ label: i.toString() + " SMMLV", value: i });

    for (let i = this.salaryMin; i <= this.salaryMax; i++)
      this.salaryMaxOptions.push({ label: i.toString() + " SMMLV", value: i });

    this.displaySidebarJustification = false;
    this.displaySidebarTask = false;

    this.employeePositionToLoadSelection = "4,5,6,21,38,40";

    this.loading = true;
    this.modExportDialog = false;

    this.listRequisitionJustification = [];
    this.listAbierta = [];
    this.listCerrada = [];
  }

  ngOnInit() {
    this.page = 1;
    this.per_page = 10;
    this.sort = "-id";

    this.createForm();
    this.createForm2();

    this.createForm3();
    this.createForm4(null);

    this.reloadInterval = setInterval(() => {
      this.filter(this.form3.value);
    }, this.timeReload);
  }

  ngOnDestroy() {
    // Will clear when component is destroyed e.g. route is navigated away from.
    clearInterval(this.reloadInterval);
  }

  createForm(data: any = null) {
    data = data || {
      justification: "",
    };
  }
  createForm2(data: any = null) {
    data = data || {
      justification: "",
    };
    this.form2 = this.fb.group({
      justification: new FormControl(
        data.justification,
        Validators.compose([Validators.required, Validators.minLength(2)])
      ),
    });
  }

  createForm3(data: any = null) {
    data = data || {
      company_id_filter: "",
      employee_id_filter: "",
      venue_id_filter: "",
      status_filter: "",
      type_filter: "",
      recruited_by_id_filter: "",
      requisition_recruitment_filter: "",
      offer_primary_area_filter: "",
      publish_offer_filter: "",
      profile_survey_level_filter: "",
      salary_filter: "",
      salary_min_filter: "",
      salary_max_filter: "",
    };

    this.form3 = this.fb.group({
      company_id_filter: new FormControl(data.company_id_filter),
      employee_id_filter: new FormControl(data.employee_id_filter),
      venue_id_filter: new FormControl(data.venue_id_filter),
      status_filter: new FormControl(data.status_filter),
      type_filter: new FormControl(data.type_filter),
      recruited_by_id_filter: new FormControl(data.recruited_by_id_filter),
      requisition_recruitment_filter: new FormControl(
        data.requisition_recruitment_filter
      ),
      offer_primary_area_filter: new FormControl(
        data.offer_primary_area_filter
      ),
      publish_offer_filter: new FormControl(data.publish_offer_filter),
      profile_survey_level_filter: new FormControl(
        data.profile_survey_level_filter
      ),
      salary_min_filter: new FormControl(data.salary_min_filter),
      salary_max_filter: new FormControl(data.salary_max_filter),
    });
  }

  createForm4(data: any = null) {
    data = data || {
      f4_date_start: "",
      f4_date_end: "",
      f4_venue_id: "",
      f4_employee_id: "",
      f4_company_id: "",
      f4_status_filter: "",
      f4_type_filter: "",
      f4_export_filter: "",
      f4_export_type_filter: "excel",
    };

    this.form4 = this.fb.group({
      f4_date_start: new FormControl(
        data.f4_date_start,
        Validators.compose([Validators.required])
      ),
      f4_date_end: new FormControl(
        data.f4_date_end,
        Validators.compose([Validators.required])
      ),
      f4_venue_id: new FormControl(data.f4_venue_id),
      f4_employee_id: new FormControl(data.f4_employee_id),
      f4_company_id: new FormControl(data.f4_company_id),
      f4_status_filter: new FormControl(
        data.f4_status_filter,
        Validators.compose([Validators.required])
      ),
      f4_type_filter: new FormControl(
        data.f4_type_filter,
        Validators.compose([Validators.required])
      ),
      f4_export_filter: new FormControl(data.f4_export_filter),
      f4_export_type_filter: new FormControl(data.f4_export_type_filter),
    });
  }

  public loadRequisitionsLazy(event: LazyLoadEvent) {
    this.page = event.first / this.per_page + 1;
    if (event.sortOrder === -1) {
      this.sort = "-" + event.sortField;
    } else {
      this.sort = event.sortField;
    }

    if (event.globalFilter) {
      this.query = event.globalFilter;
    } else {
      this.query = undefined;
    }

    this.sort = "-id";

    this.filter(this.form3.value);
  }

  showSidebarJustification(requisition) {
    this.selectRequisition = requisition;
    this.displaySidebarJustification = true;
    this.reloadListKanban(requisition);
  }

  closeSidebarJustification() {
    this.form2.reset();
    this.selectRequisition = undefined;
    this.displaySidebarJustification = false;
  }

  public newRequisitionJustification(values) {
    const param = {
      justification: values.justification,
      requisition_id: this.selectRequisition.id,
    };
    if (values && this.form2.valid) {
      const promise =
        this.requisitionJustificationService.newRequisitionJustification(
          this.selectRequisition.id,
          param
        );

      this.promiseForm = promise.toPromise().then(
        (response) => {
          this.getRequisitionJustification(this.selectRequisition.id);
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
          this.closeSidebarJustification();
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "Error" });
        }
      );
    }
  }

  getRequisitionJustification(id: number) {
    var _with = "profile_survey,requisition_justification";
    this.requisitionService
      .infoRequisition(id, _with)
      .toPromise()
      .then(
        (response) => {
          this.edit1.requisition_justification =
            response.json().data[0].requisition_justification;
          this.form2.reset();
          if (
            response.json().meta.total > response.json().meta.total_filtered
          ) {
            this.totalRecordsRequisitionJustification =
              response.json().meta.total_filtered;
          } else {
            this.totalRecordsRequisitionJustification =
              response.json().meta.total;
          }
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  showSidebarTask(requisition) {
    this.selectRequisition = requisition;
    this.displaySidebarTask = true;
  }

  closeSidebarTask() {
    this.form2.reset();
    this.selectRequisition = undefined;
    this.displaySidebarTask = true;
  }

  public getRequisitions() {
    this.loading = true;
    this.requisitionService
      .getRequisition(
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters
      )
      .toPromise()
      .then(
        (response) => {
          this.loading = false;
          this.requisitions = response.json().data;
          for (var i = 0; i < this.requisitions.length; i++)
            this.requisitions[i].profile_survey.salary =
              this.getNumberValidation(
                this.requisitions[i].profile_survey.salary
              );

          if (response.json().meta.total > response.json().meta.total_filtered)
            this.totalRecords = response.json().meta.total_filtered;
          else this.totalRecords = response.json().meta.total;
        },
        (error) => {
          this.loading = false;
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  public getRequisitionsByCustomerguide(id: number) {
    this.loading = true;
    this.requisitionService
      .getRequisitionByCustomerGuide(
        id,
        this.page,
        this.per_page,
        this.sort,
        this.query,
        this.filters
      )
      .toPromise()
      .then(
        (response) => {
          this.loading = false;
          this.requisitions = response.json().data;
          if (
            response.json().meta.total > response.json().meta.total_filtered
          ) {
            this.totalRecords = response.json().meta.total_filtered;
          } else {
            this.totalRecords = response.json().meta.total;
          }
        },
        (error) => {
          this.loading = false;
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  public newRequisition() {
    this.modNew = !this.modNew;
    this.selectRequisition = null;
  }

  public savedRequisition(res) {
    this.msgs = [];
    this.msgs.push(res);
    this.selectRequisition = null;
    this.modNew = false;
  }

  public cancelRequisition(res) {
    this.selectRequisition = null;
    this.modNew = false;
    this.modView = false;
  }

  public edit(requisition: Requisition) {
    this.modNew = true;
    this.selectRequisition = requisition;
  }

  public view(requisition: Requisition) {
    this.openRequisition = true;
    this.selectRequisition = requisition;
    this.RequisitionID = requisition.id;
    this.modView = true;
  }

  public deleteDialog(requisition: Requisition) {
    let message;
    this.translate.get("Do you want to delete?").subscribe((res: string) => {
      message = res;
    });

    let header;
    this.translate.get("Delete Confirmation").subscribe((res: string) => {
      header = res;
    });

    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: "fa fa-trash",
      accept: () => {
        this.delete(requisition);
      },
    });
  }

  public delete(requisition: Requisition) {
    this.requisitionService
      .deleteRequisition(requisition.id)
      .toPromise()
      .then(
        (response) => {
          this.msgs = [];
          this.msgs.push({ severity: "success", summary: "deleted" });
          if (this.customerGuide) {
            this.getRequisitionsByCustomerguide(this.customerGuide);
          } else {
            this.getRequisitions();
          }
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  public activeRequisition(requisition: Requisition) {
    this.putRequisition(requisition);
  }

  public putRequisition(values: Requisition) {
    const param = {
    };
    if (values) {
      const promise = this.requisitionService.updateRequisition(
        values.id,
        param
      );
      this.promiseForm = promise.toPromise().then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
        },
        (error) => {
          this.msgs.push({ severity: "error", summary: "Error" });
        }
      );
    }
  }

  public reloadListKanban(requisition) {
    this.listAbierta = [];
    this.listCerrada = [];

    requisition.requisition_task.forEach((element) => {
      if (element.status === "Abierta") {
        element.textColor = "#FFFFFF";
        element.color = "#ffc107";
        this.listAbierta.push(element);
      }
      if (element.status === "Cerrada") {
        element.textColor = "#FFFFFF";
        element.color = "#28a745";
        this.listCerrada.push(element);
      }
    });
  }

  public onDropSuccessAbierta(e) {
    e.status = "Abierta";
    const index = this.findElement(
      this.selectRequisition.requisition_task,
      e.id
    );
    this.selectRequisition.requisition_task[index].status = "Abierta";
    this.selectRequisition.requisition_task[index].color = "#ffc107";
    this.putRequisitionTask(e);
  }

  public onDropSuccessCerrada(e) {
    e.status = "Cerrada";
    const index = this.findElement(
      this.selectRequisition.requisition_task,
      e.id
    );
    this.selectRequisition.requisition_task[index].status = "Cerrada";
    this.selectRequisition.requisition_task[index].color = "#28a745";
    this.putRequisitionTask(e);
  }

  public findElement(list, search) {
    let find = -1;
    let itera = 0;
    list.forEach((element) => {
      if (element.id === search) {
        find = itera;
      }
      itera++;
    });
    return find;
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }
  public hasRole(rol) {
    var r: boolean = false;
    var role = JSON.parse(localStorage.getItem("profile")).roles[0].id;
    if (role == rol) {
      r = true;
    }
    return r;
  }

  public filterRefresh() {
    this.customerGuide = undefined;
    this.filter(this.form3.value, true);
  }

  public filter(values?, pageRefresh?) {
    if (pageRefresh) {
      this.page = 1;
      this.first = 0;
    }

    this.filters = [];
    if (values.company_id_filter) {
      if (values.company_id_filter.id) {
        if (values.company_id_filter.customer_guide.activated == 1) {
          if (
            values.company_id_filter.id == 5 ||
            values.company_id_filter.id == 323
          ) {
            if (!this.hasPermission("get company redes")) {
              values.company_id_filter.id = undefined;
            }
          }
          this.customerGuide = values.company_id_filter.customer_guide.id;
          this.companyId = values.company_id_filter.id;
          this.filters.push({
            key: "customer_guide_id-lk",
            value: values.company_id_filter.customer_guide.id,
          });
        }
      }
    }
    if (values.employee_id_filter) {
      if (values.employee_id_filter) {
        this.filters.push({
          key: "employee_id-lk",
          value: values.employee_id_filter.id,
        });
      }
    }
    if (values.venue_id_filter) {
      if (values.venue_id_filter) {
        this.filters.push({
          key: "venue_id-lk",
          value: values.venue_id_filter,
        });
      }
    }
    if (
      values.status_filter.length > 0 &&
      values.status_filter.indexOf("all") == "-1" &&
      values.status_filter.indexOf("") == "-1"
    )
      this.filters.push({ key: "status-in", value: values.status_filter });

    if (
      values.type_filter.length > 0 &&
      values.type_filter.indexOf("all") == "-1" &&
      values.type_filter.indexOf("") == "-1"
    ) {
      this.filters.push({ key: "type-in", value: values.type_filter });
    }
    if (values.recruited_by_id_filter) {
      this.filters.push({
        key: "employee_recruitment_id",
        value: values.recruited_by_id_filter.id,
      });
    }
    if (values.offer_primary_area_filter) {
      this.filters.push({
        key: "offer_primary_area_id",
        value: values.offer_primary_area_filter,
      });
    }

    if (
      values.publish_offer_filter != "" &&
      values.publish_offer_filter != null &&
      values.publish_offer_filter != undefined
    ) {
      if (
        values.publish_offer_filter == "true" ||
        values.publish_offer_filter == true
      )
        this.filters.push({ key: "publish_offer", value: "1" });
      else this.filters.push({ key: "publish_offer", value: "0" });
    }

    if (
      values.profile_survey_level_filter != "" &&
      values.profile_survey_level_filter != null &&
      values.profile_survey_level_filter != undefined
    )
      this.filters.push({
        key: "profile_survey_level-in",
        value: values.profile_survey_level_filter,
      });

    if (
      values.salary_min_filter !== null &&
      values.salary_min_filter !== "" &&
      values.salary_min_filter !== undefined
    )
      this.filters.push({ key: "salary-min", value: values.salary_min_filter });

    if (
      values.salary_max_filter !== null &&
      values.salary_max_filter !== "" &&
      values.salary_max_filter !== undefined
    )
      this.filters.push({ key: "salary-max", value: values.salary_max_filter });

    if (values.requisition_recruitment_filter) {
      if (values.requisition_recruitment_filter == "Reclutamiento solicitado") {
        this.filters.push({ key: "requested_recruitment", value: "1" });
      } else if (
        values.requisition_recruitment_filter ==
        "Reclutamiento solicitado no asignado"
      ) {
        this.filters.push({ key: "requested_recruitment", value: "1" });
        this.filters.push({ key: "employee_recruitment_id", value: null });
      } else this.filters.push({ key: "requested_recruitment-lk", value: "" });
    }
    if (this.customerGuide) {
      this.getRequisitionsByCustomerguide(this.customerGuide);
    } else {
      this.getRequisitions();
    }
  }

  getRequisitionsById(query?: string, filters?: any[]) {
    this.loading = true;
    this.requisitionService
      .getRequisition(this.page, this.per_page, this.sort, query, filters)
      .toPromise()
      .then(
        (response) => {
          this.loading = false;
          this.edit(response.json().data[0]);
        },
        (error) => {
          this.loading = false;
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: "error" });
        }
      );
  }

  public gotoCitations(id) {
    this.router.navigate(["/pages/selection/citations"], {
      queryParams: { id_requisition: id },
    });
  }

  getCompanies(query?: string, filters?: any[]) {
    this.companyService
      .getCompany(this.page, this.per_page, this.sort, query, filters)
      .toPromise()
      .then(
        (response) => {
          const companiesOptions = response.json().data;
          this.form3.controls.company_id_filter.setValue(companiesOptions[0]);
        },
        (error) => {
          this.form3.controls.company_id_filter.setValue(undefined);
        }
      );
  }

  public showExportDialog() {
    this.modExportDialog = true;
  }

  public cancelExport() {
    this.modExportDialog = false;
  }

  public exportReport(values) {
    if (values.f4_export_filter === "pdf") {
      this.exportReportPdf(values);
    } else if (values.f4_export_filter === "excel") {
      this.exportReportExcel(values);
    } else {
      this.exportReportEmail(values);
    }
  }

  public exportReportPdf(values) {
    let d = new Date(values.f4_date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    const f4_date_start = formatDate(d);

    d = new Date(values.f4_date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);
    const f4_date_end = formatDate(d);

    let url =
      this.apiUrl +
      "/requisitions/getReportRequisitionPDF?" +
      "token=" +
      localStorage.getItem("token") +
      "&_page=1&_limit=100000&_sort=venue_id,employee_id,company_id&";

    if (f4_date_start) {
      url = url + "requested_at-min=" + f4_date_start + "&";
    }

    if (f4_date_end) {
      url = url + "requested_at-max=" + f4_date_end + "&";
    }

    if (values.f4_venue_id) {
      url = url + "venue_id-in=" + values.f4_venue_id + "&";
    }

    if (values.f4_employee_id) {
      url = url + "employee_id-in=" + values.f4_employee_id.id + "&";
    }

    if (values.f4_status_filter !== "all" && values.f4_status_filter !== "") {
      url = url + "status-in=" + values.f4_status_filter + "&";
    }

    if (values.f4_type_filter !== "all" && values.f4_type_filter !== "") {
      url = url + "type=" + values.f4_type_filter + "&";
    }

    if (values.f4_export_type_filter) {
      url = url + "type_export=" + values.f4_export_type_filter.value + "&";
    }

    window.open(url, "_blank");
  }

  public exportReportExcel(values) {
    let d = new Date(values.f4_date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    const f4_date_start = formatDate(d);

    d = new Date(values.f4_date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);
    const f4_date_end = formatDate(d);

    let url =
      this.apiUrl +
      "/requisitions/excel?" +
      "token=" +
      localStorage.getItem("token") +
      "&_page=1&_limit=100000&_sort=venue_id,employee_id,company_id&";

    if (f4_date_start) {
      url = url + "requested_at-min=" + f4_date_start + "&";
    }

    if (f4_date_end) {
      url = url + "requested_at-max=" + f4_date_end + "&";
    }

    if (values.f4_venue_id) {
      url = url + "venue_id-in=" + values.f4_venue_id + "&";
    }

    if (values.f4_employee_id) {
      url = url + "employee_id-in=" + values.f4_employee_id.id + "&";
    }

    if (values.f4_company_id) {
      url = url + "company_id-in=" + values.f4_company_id.id + "&";
    }
    if (values.f4_status_filter.indexOf("all") == "-1") {
      url = url + "status-in=" + values.f4_status_filter + "&";
    }

    if (values.f4_type_filter.indexOf("all") == "-1") {
      url = url + "type-in=" + values.f4_type_filter + "&";
    }

    if (values.f4_export_type_filter) {
      url = url + "type_export=" + values.f4_export_type_filter.value + "&";
    }

    window.open(url, "_blank");
  }

  public exportReportEmail(values) {
    let d = new Date(values.f4_date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    const f4_date_start = formatDate(d);

    d = new Date(values.f4_date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);
    const f4_date_end = formatDate(d);

    let url =
      this.apiUrl +
      "/requisitions/email?" +
      "token=" +
      localStorage.getItem("token") +
      "&_page=1&_limit=100000&_sort=venue_id,employee_id,company_id&";

    if (f4_date_start) {
      url = url + "requested_at-min=" + f4_date_start + "&";
    }

    if (f4_date_end) {
      url = url + "requested_at-max=" + f4_date_end + "&";
    }

    if (values.f4_venue_id) {
      url = url + "venue_id-in=" + values.f4_venue_id + "&";
    }

    if (values.f4_employee_id) {
      url = url + "employee_id-in=" + values.f4_employee_id.id + "&";
    }

    if (values.f4_status_filter !== "all" && values.f4_status_filter !== "") {
      url = url + "status-in=" + values.f4_status_filter + "&";
    }

    if (values.f4_type_filter !== "all" && values.f4_type_filter !== "") {
      url = url + "type-in=" + values.f4_type_filter + "&";
    }

    if (values.f4_export_type_filter) {
      url = url + "type=" + values.f4_export_type_filter.value + "&";
    }

    window.open(url, "_blank");
  }

  getDiffDate(value) {
    let dateStart = new Date(value.requested_at);

    let dateEnd;

    if (value.wait_client_at) {
      dateEnd = new Date(value.wait_client_at);
    } else if (value.closed_at) {
      dateEnd = new Date(value.closed_at);
    } else {
      dateEnd = new Date();
    }

    const diff = dateEnd.getTime() - dateStart.getTime();
    return Math.ceil(diff / (1000 * 3600 * 24));
  }

  showFormCreateTask() {
    this.showCreateTask = true;
  }

  hideFormCreateTask() {
    this.showCreateTask = false;
    this.closeSidebarJustification();
  }

  public putRequisitionTask(values: RequisitionTask) {
    const param = {
      status: values.status,
    };
    if (values) {
      const promise = this.requisitionTaskService.updateRequisitionTask(
        values.id,
        param
      );
      this.promiseForm = promise.toPromise().then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
          this.reloadListKanban(this.selectRequisition);
        },
        (error) => {
          this.msgs.push({ severity: "error", summary: "Error" });
        }
      );
    }
  }
  getDiffDateSendCustomer(value) {
    let dateStart = new Date(value.requested_at);
    var dateEnd = new Date(value.requested_at);
    let weekDay = dateEnd.getDay();
    var sumdays = 0;
    if (weekDay == 1 || weekDay == 2) sumdays = 4;
    else if (weekDay == 3 || weekDay == 5) sumdays = 6;
    else if (weekDay == 4) sumdays = 5;
    else sumdays = 5;
    dateEnd.setDate(dateEnd.getDate() + sumdays);

    var countSendCustomeratTime = 0;
    if (value.citation_count > 0) {
      value.citation.forEach((citation) => {
        if (citation.start_send_customer != null) {
          let dateSendCustomer = new Date(citation.start_send_customer);
          if (dateSendCustomer < dateEnd) countSendCustomeratTime++;
        }
      });
      if (countSendCustomeratTime > 0) return "Cumple";
      else return this.comparedatelimit(dateStart, sumdays);
    } else return this.comparedatelimit(dateStart, sumdays);
  }

  public comparedatelimit(dateStart, sumdays) {
    var inicio = new Date();
    const diff = inicio.getTime() - dateStart.getTime();
    var daysCount = Math.ceil(diff / (1000 * 3600 * 24));

    if (daysCount > sumdays) return "No cumple";
    else return "-";
  }

  public getNumberValidation(item) {
    if (isNaN(item)) item = null;
    return item;
  }

  public isNumericValue(value: any): boolean {
    if (value === null || value === undefined || value === "") return false;
    if (typeof value === "number") return !isNaN(value);

    const normalizedValue = value
      .toString()
      .trim()
      .replace(/\./g, "")
      .replace(/,/g, ".");

    return !isNaN(Number(normalizedValue));
  }

  public parseNumericValue(value: any): number {
    if (typeof value === "number") return value;

    return Number(
      value
        .toString()
        .trim()
        .replace(/\./g, "")
        .replace(/,/g, ".")
    );
  }

  public updateValueMaxOptions(
    value_min_form: any,
    value_max_form: any,
    form_name: string,
    array_max_options: any[],
    concept: string,
    min_value,
    max_value
  ) {
    if (
      value_min_form == null ||
      value_min_form == "" ||
      value_min_form == undefined
    ) {
      array_max_options = [];

      for (let i = min_value; i <= max_value; i++)
        array_max_options.push({ label: i.toString() + concept, value: i });
    } else {
      array_max_options = [];

      for (let i = value_min_form; i <= max_value; i++)
        array_max_options.push({ label: i.toString() + concept, value: i });
    }

    if (value_max_form < value_min_form) this.form3.get(form_name).setValue("");

    if (form_name == "salary_max_filter")
      this.salaryMaxOptions = array_max_options;
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/requisitions/requisitions.component.ts